<template>
  <section v-if="modelValue !== null">
    <article class="counter-party">
      <h3>{{ content.TitleCounterparty }} {{ index + 1 }}</h3>
      <div class="control">
        <div class="row">
          <label
            for="counterPartyKnownLicensePlates"
            v-html="content.IsCounterPartyLicensePlateKnownText"
            class="text-question columns small-6"
          />
          <radio-buttons-capsule-pill
            id="counterPartyKnownLicensePlates"
            :model-value="isCounterPartyLicensePlateKnown"
            name="counterPartyKnownLicensePlates"
            data-test-yes="counter-party-known-license-plates-yes"
            data-test-no="counter-party-known-license-plates-no"
            @update:modelValue="onIsCounterPartyLicensePlateKnownChange"
          />
        </div>
        
        <div v-if="isCounterPartyLicensePlateKnown" class="row">
          <label
            for="counterPartyDanishLicensePlates"
            v-html="content.IsCounterPartyLicensePlateDanishText"
            class="text-question columns small-6"
          />
          <radio-buttons-capsule-pill
            id="counterPartyDanishLicensePlates"
            :model-value="isCounterPartyLicensePlateDanish"
            name="counterPartyDanishLicensePlates"
            data-test-yes="counter-party-danish-license-plates-yes"
            data-test-no="counter-party-danish-license-plates-no"
            @update:modelValue="onIsCounterPartyLicensePlateDanishChange"
          />
          <div class="small-12 columns">
            <Field
              v-model="licensePlate"
              v-slot="{ field, meta }"
              :rules="{
                required: !valid,
                min: 3,
                license_plate_exists: isCounterPartyLicensePlateDanish ? true : false,
                is_not: claimLicenseplate
              }"
              :name="name('licenseplate')"
              label="Nummerplade"
            >
              <label
                :for="name('licenseplate')"
                class="text-question"
                v-html="content.LabelCounterPartyLicenseplate"
              />
              <div class="row">
                <div class="columns small-12">
                  <base-license-plate-search
                    v-bind="field"
                    data-vv-delay="500"
                    :block-search="hasSameLicenseplate"
                    @license-plate-found="licensePlateFound($event)"
                    @license-plate-not-found="licensePlateString = $event"
                    @license-plate-dmr-lookup-is-success="dmrLookupIsSuccess = $event"
                    :errors="errors"
                    :model-value="modelValue.RegistrationNumber"
                    @update:model-value="updateLicensePlate"
                  />
                </div>
                <div class="columns small-8">
                  <p
                    v-if="showCarInfo"
                    data-test-counterparty-car-info
                    class="car color-gray"
                    v-text="licensePlateString"
                  />
                </div>
              </div>

              <info-box
                v-if="meta.errors.length > 0 || licensePlate === null || isDmrOffline"
                arrow-align="left"
                name="counterparty-info-box"
                :text="infoText"
              />
            </Field>
          </div>
            <div class="small-12 columns" v-if="!isCounterPartyLicensePlateDanish">
              <!-- Counter Party Car Registration Country -->
              <div class="row small-12">
                <label
                  for="counterPartyRegistrationCountryKnown"
                  v-html="content.IsCounterPartyRegistrationCountryKnownText"
                  class="text-question columns small-6"
                />
              <radio-buttons-capsule-pill
                id="counterPartyRegistrationCountryKnown"
                :model-value="isCounterPartyRegistrationCountryKnown"
                name="counterPartyRegistrationCountryKnown"
                data-test-yes="counter-party-registration-country-known-yes"
                data-test-no="counter-party-registration-country-known-no"
                @update:modelValue="onIsCounterPartyRegistrationCountryKnownChange"
              />
            </div>
            <div v-if="isCounterPartyRegistrationCountryKnown">
              <label
                :for="name('registration-country')"
                class="push-up text-question"
                v-html="content.CounterpartyRegistrationCountryText"
              />
              <Field
                v-slot="{ field }"
                :rules="{required: !valid }"
                v-model="selectedCounterPartyRegistrationCountry"
                :name="name('registration-country')"
              >
                <VueSelect
                  id="registrationCountry"
                  v-bind="field"
                  v-model="selectedCounterPartyRegistrationCountry"
                  :name="name('registration-country')"
                  :options="countries"
                  label="Label"
                  class="v-select-search-icon"
                  :data-test="name('registration-country')"
                  @update:model-value="(newValue) => { selectedCounterPartyRegistrationCountry = newValue; emit(); }"
                />
                <ValidationError :name="field.name" :overrides="{ required: 'Angiv venligst' }" />
              </Field>
              </div>
          </div>
        </div>
        <div class="row small-12">
          <label
            for="counterpartyContactInformation"
            v-html="content.CounterpartyContactInformationText"
            class="text-question columns small-6"
          />
          <radio-buttons-capsule-pill
            id="counterpartyContactInformation"
            :model-value="isCounterpartyContactInformationKnown"
            name="counterpartyContactInformation"
            data-test-yes="counter-party-contact-information-yes"
            data-test-no="counter-party-contact-information-no"
            @update:modelValue="onCounterPartyContactInformationChange"
          />
        </div>
      </div>

      <div v-if="isCounterpartyContactInformationKnown" class="row small-12">
        <label
          for="counterpartyHasDanishResidence"
          v-html="content.CounterpartyHasDanishResidenceText"
          class="text-question columns small-6"
        />
        <radio-buttons-capsule-pill
          id="counterpartyHasDanishResidence"
          :model-value="counterPartyHasDanishResidence"
          name="counterpartyHasDanishResidence"
          data-test-yes="counter-party-danish-residence-yes"
          data-test-no="counter-party-danish-residence-no"
          @update:modelValue="onCounterpartyHasDanishResidenceChange"
        />
        <div class="column small-12">
          <div v-if="!counterPartyHasDanishResidence">
            <label
              :for="name('residence-country')"
              class="push-up text-question"
              v-html="content.CounterPartyInternationalCountryText"
            />
            <Field
              v-slot="{ field }"
              :rules="{ required: !valid }"
              v-model="counterPartyInternationalAddress.country"
              :name="name('residence-country')"
            >
              <VueSelect
                id="residenceCountry"
                v-bind="field"
                v-model="counterPartyInternationalAddress.country"
                :name="name('residence-country')"
                :options="countries"
                label="Label"
                class="v-select-search-icon"
                :data-test="name('country-of-residence')"
                @update:model-value="(newValue) => { counterPartyInternationalAddress.country = newValue; emit(); }"
              />
              <ValidationError :name="field.name" :overrides="{ required: 'Angiv venligst' }" />
            </Field>
            <h3 class="push-up push-down" v-html="content.CounterPartyAddressTitle" />
          </div>

        <!-- Counter Party First Name -->
          <div class="control">
            <label
              :for="name('first-name')"
              class="text-question"
              v-html="content.LabelCounterPartyFirstName"
            />
            <Field
              v-slot="{ field }"
              v-model="firstName"
              :rules="{ required: !valid, max: 50 }"
              :name="name('first-name')"
            >
              <base-text-input v-bind="field" maxlength="50" @input="emit" :errors="errors" />
            </Field>
          </div>

          <!-- Counter Party Last Name -->
          <div class="control">
            <label
              :for="name('last-name')"
              class="text-question"
              v-html="content.LabelCounterPartyLastName"
            />
            <Field
              v-slot="{ field }"
              v-model="lastName"
              :rules="{ required: !valid, max: 50 }"
              :name="name('last-name')"
            >
              <base-text-input v-bind="field" maxlength="50" @input="emit" :errors="errors" />
            </Field>
          </div>

          <!-- Counter Party Address -->
          <div class="control" v-if="counterPartyHasDanishResidence">
            <label
              :for="name('address')"
              class="text-question"
              v-html="content.LabelCounterPartyAddress"
            />
            <Field
              :model-value="selectedAddress"
              v-slot="{ field }"
              :rules="{ required: !valid }"
              :name="name('address')"
            >
              <address-search
                v-bind="field" 
                :model-value="selectedAddress"
                @update:model-value="(newValue) => { selectedAddress = newValue; emit(); }"
                :name="field.name"
                :errors="errors"
              />
            </Field>
          </div>
          <div v-else-if="!counterPartyHasDanishResidence" class="row">
            <div class="small-12 medium-6 columns">
              <label
                :for="name('international-street-name')"
                class="text-question"
                v-html="content.CounterPartyInternationalStreetNameText"
              />
              <Field
                id="counterPartyInternationalStreetName"
                v-model="counterPartyInternationalAddress.streetName"
                v-slot="{ field }"
                :rules="{ required: !valid }"
                :name="name('international-street-name')"
              >
                <base-text-input v-bind="field" maxlength="50" @input="emit" :errors="errors" />
              </Field>
            </div>
            <div class="small-12 medium-6 columns">
              <label
                :for="name('international-street-number')"
                class="text-question"
                v-html="content.CounterPartyInternationalStreetNumberText"
              />
                <Field
                  id="counterPartyInternationalStreetNumber"
                  v-model="counterPartyInternationalAddress.streetNumber"
                  v-slot="{ field }"
                  :rules="{ required: !valid }"
                  :name="name('international-street-number')"
                >
                  <base-text-input v-bind="field" maxlength="50" @input="emit" :errors="errors" />
              </Field>
            </div>
            <div class="small-12 medium-6 columns">
              <label
                :for="name('international-postal-code')"
                class="text-question"
                v-html="content.CounterPartyInternationalPostalCodeText"
              />
              <Field
                id="counterPartyInternationalPostalCode"
                v-model="counterPartyInternationalAddress.postalCode"
                v-slot="{ field }"
                :rules="{ required: !valid }"
                :name="name('international-postal-code')"
              >
                <base-text-input v-bind="field" maxlength="50" @input="emit" :errors="errors" />
            </Field>
            </div>
            <div class="small-12 medium-6 columns">
              <label
                  :for="name('international-city')"
                  class="text-question"
                  v-html="content.CounterPartyInternationalCityText"
                />
                <Field
                  id="counterPartyInternationalCity"
                  v-model="counterPartyInternationalAddress.city"
                  v-slot="{ field }"
                  :rules="{ required: !valid }"
                  :name="name('international-city')"
                >
                  <base-text-input v-bind="field" maxlength="50" @input="emit" :errors="errors" />
                </Field>
            </div>
        </div>
      </div>
        
        <!-- Counter Party Phone -->
        <div class="small-12 medium-6 columns">
          <label
            :for="name('phone')"
            class="text-question"
            v-html="content.LabelCounterPartyPhone"
          />
          <Field
            v-slot="{ field }"
            v-model="phone"
            :rules="{ required: !valid, numeric: true, min: 8 }"
            :name="name('phone')"
          >
            <base-text-input v-bind="field" maxlength="8" @input="emit" :errors="errors" />
          </Field>
        </div>

        <!-- Counter Party Email -->
        <div class="small-12 medium-6 columns">
          <label
            :for="name('email')"
            class="text-question"
            v-html="content.LabelCounterPartyEmail"
          />
          <Field
            v-slot="{ field }"
            v-model="email"
            :rules="{ required: !valid, email: true }"
            :name="name('email')"
          >
            <base-text-input v-bind="field" :id="name('email')" @input="emit" :errors="errors" />
          </Field>
        </div>
      </div>
    </article>

    <article>
      <div class="control">
        <label class="text-question" v-html="content.LabelDamageZones" />
        <br />

        <Field
          :name="name('damage-zone-known')"
          v-slot="{ field, meta }"
          v-model="damageZoneKnown"
        >
          <RadioGroupStacked
            v-bind="field"
            :options="damageZonesOptions"
            :model-value="damageZoneKnown"
            value-prop="value"
            label-prop="label"
          />
          <ValidationError :name="field.name" v-if="meta.touched && !meta.valid" :overrides="{ required: 'Angiv venligst' }" />
        </Field>

        <damage-zones
          v-if="damageZoneKnown"
          :id="'counterparty-' + index"
          v-model="damageZones"
          :options="stepModel.DamageZoneOptions"
          @update:model-value="emit"
          :errors="errors"
        />
      </div>
    </article>
  </section>
</template>

<script>
import DamageZones from './DamageZones.vue';
import AddressSearch from '@/components/UI/AddressSearch.vue';
import BaseLicensePlateSearch from '@/components/Forms/BaseLicensePlateSearch/BaseLicensePlateSearch.vue';
import BaseTextInput from '@/components/Forms/BaseTextInput.vue';
import InfoBox from '@/components/UI/InfoBox.vue';
import RadioButtonsCapsulePill from '@/components/Forms/RadioButtonsCapsulePill.vue';
import { isEmpty } from 'lodash';

export default {
  name: 'Counterparty',
  components: {
    AddressSearch,
    BaseLicensePlateSearch,
    BaseTextInput,
    DamageZones,
    InfoBox,
    RadioButtonsCapsulePill
  },
  // inject: ['$validator'],
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    },
    index: {
      type: Number,
      default() {
        return null;
      }
    },
    content: {
      type: Object,
      default() {
        return null;
      }
    },
    stepModel: {
      type: Object,
      default() {
        return null;
      }
    },
    countryCode: {
      type: Number,
      default() {
        return null;
      }
    },
    countries: {
      type: Array,
      required: true,
      default() {
        return null;
      }
    },
    claimLicenseplate: {
      type: String,
      default() {
        return null;
      }
    },
    errors: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      licensePlate: null,
      damageZoneKnown: null,
      firstName: null,
      lastName: null,
      selectedAddress: null,
      email: null,
      phone: null,
      damageZones: null,
      address: {
        ContactAddressId: null,
        Id: null,
        Street: null,
        HouseNumber: null,
        Floor: null,
        Designation: null,
        District: null,
        PostalCode: null,
        City: null,
        CountryRef: null,
        CountryName: null,
        CountryCode: this.countryCode,
        IsForeignAddress: null,
        Locality: null
      },
      selectedCounterPartyRegistrationCountry: null,
      licensePlateString: null,
      dmrLookupIsSuccess: null,
      isCounterPartyLicensePlateKnown: true,
      isCounterPartyLicensePlateDanish: true,
      isCounterPartyRegistrationCountryKnown: true,
      isCounterpartyContactInformationKnown: true,
      counterPartyHasDanishResidence: true,
      counterPartyInternationalAddress: {
        streetName: null,
        streetNumber: null,
        city: null,
        postalCode: null,
        country: null
      },
    };
  },
  computed: {
    damageZonesOptions() {
      return [
        {
          value: true,
          label: this.content.LabelAndTooltipDamagezoneKnown
        },
        {
          value: false,
          label: this.content.LabelAndTooltipDamagezoneNotKnown
        }
      ];
    },
    valid() {
      if (!isEmpty(this.licensePlate) && isEmpty(this.errors[this.name('licenseplate')])) {
        return true;
      }
      if (!isEmpty(this.phone) && isEmpty(this.errors[this.name('phone')])) {
        return true;
      }
      if (!isEmpty(this.email) && isEmpty(this.errors[this.name('email')])) {
        return true;
      }
      if (!isEmpty(this.firstName) && !isEmpty(this.lastName) && !isEmpty(this.selectedAddress)) {
        return true;
      }

      return false;
    },
    hasSameLicenseplate() {
      return this.licensePlate === this.claimLicenseplate;
    },
    showCarInfo() {
      return !this.hasSameLicenseplate && this.licensePlateString !== null;
    },
    isInvalidLicensePlate() {
      // return this.errors.items.filter((obj) => obj.rule === 'license_plate_exists').length > 0;
      return this.errors['counterparty-' + this.index + '-licenseplate'] === 'Registreringsnummer kunne ikke findes';
    },
    isClaimHolderLicensePlate() {
      return this.errors['counterparty-' + this.index + '-licenseplate'] === 'Nummerplade er ikke gyldig.';

      // return this.errors.items.filter((obj) => obj.rule === 'is_not').length > 0;
    },
    isDmrOffline() {
      return this.dmrLookupIsSuccess === false ?? false;
    },
    infoText() {
      if (this.isInvalidLicensePlate) {
        return this.content.ErrorMessageCounterPartyDmrVerificationError;
      }

      if (this.isClaimHolderLicensePlate) {
        return this.content.ErrorMessageCounterPartySameLicenseplate;
      }

      if (this.isDmrOffline) {
        return this.content.ErrorMessageCounterPartyDmrOffline;
      }

      return this.content.InfoBoxCounterparty;
    }
  },
  watch: {
    damageZoneKnown(val) {
      if (!val) {
        this.damageZones = [];
        this.emit();
      }
    }
  },
  mounted() {
    if (
      this.modelValue === null ||
      this.index === null ||
      this.content === null ||
      this.stepModel === null ||
      this.countryCode === null
    ) {
      return;
    }

    this.licensePlate = this.modelValue.RegistrationNumber;
    this.damageZoneKnown = this.modelValue.DamageZoneKnown;
    this.firstName = this.modelValue.ContactInformation.FirstName;
    this.lastName = this.modelValue.ContactInformation.LastName;
    this.selectedAddress = this.modelValue.ContactInformation.SelectedAddress;
    this.email = this.modelValue.ContactInformation.Email;
    this.phone = this.modelValue.ContactInformation.Phone;
    this.damageZones = this.modelValue.DamageZones;

    this.isCounterPartyLicensePlateKnown = this.modelValue.IsCounterPartyLicensePlateKnown;
    this.isCounterPartyLicensePlateDanish = this.modelValue.IsCounterPartyLicensePlateDanish;
    this.isCounterPartyRegistrationCountryKnown = this.modelValue.IsCounterPartyRegistrationCountryKnown;
    this.isCounterpartyContactInformationKnown = this.modelValue.IsCounterpartyContactInformationKnown;
    this.counterPartyHasDanishResidence = this.modelValue.CounterPartyHasDanishResidence;

    if (this.modelValue.CounterPartyCarRegistrationCountry !== null) {
      this.selectedCounterPartyRegistrationCountry = {
        Label: this.modelValue.CounterPartyCarRegistrationCountry
      };
    }

    if (!this.modelValue.CounterPartyHasDanishResidence) {
      this.counterPartyInternationalAddress.streetName = this.modelValue.ContactInformation.Address.Street;
      this.counterPartyInternationalAddress.streetNumber = this.modelValue.ContactInformation.Address.HouseNumber;
      this.counterPartyInternationalAddress.city = this.modelValue.ContactInformation.Address.City;
      this.counterPartyInternationalAddress.postalCode = this.modelValue.ContactInformation.Address.PostalCode;

      this.counterPartyInternationalAddress.country = {
        Id: this.modelValue.ContactInformation.Address.CountryCode,
        Label: this.modelValue.ContactInformation.Address.CountryName
      };
    }
  },
  methods: {
    async emit() {
      await this.$nextTick();

      if (this.selectedAddress !== null && this.counterpartyHasDanishResidence) {
        this.address.ContactAddressId = 0;
        this.address.Id = 0;
        this.address.Street = this.selectedAddress.adresse.vejnavn;
        this.address.HouseNumber = this.selectedAddress.adresse.husnr;
        this.address.Floor = this.selectedAddress.adresse.etage;
        this.address.Designation = this.selectedAddress.adresse.dør;
        this.address.District = this.selectedAddress.adresse.supplerendebynavn;
        this.address.PostalCode = this.selectedAddress.adresse.postnr;
        this.address.City = this.selectedAddress.adresse.postnrnavn;
        this.address.CountryRef = 0;
        this.address.CountryName = null;
        this.address.CountryCode = this.countryCode;
        this.address.IsForeignAddress = false;
        this.address.Locality = null;
      }

      if (!this.counterPartyHasDanishResidence) {
        this.selectedAddress = this.counterPartyInternationalAddress;
        this.address.Street = this.counterPartyInternationalAddress.streetName;
        this.address.HouseNumber = this.counterPartyInternationalAddress.streetNumber;
        this.address.City = this.counterPartyInternationalAddress.city;
        this.address.PostalCode = this.counterPartyInternationalAddress.postalCode;
        this.address.ContactAddressId = 0;
        this.address.Id = 0;
        this.address.Floor = null;
        this.address.Designation = null;
        this.address.District = null;
        this.address.CountryRef = this.counterPartyInternationalAddress?.country?.Id;
        this.address.CountryName = this.counterPartyInternationalAddress?.country?.Label;
        this.address.CountryCode = this.counterPartyInternationalAddress?.country?.Id;
        this.address.IsForeignAddress = true;
        this.address.Locality = null;
      }

      this.$emit('update:model-value', {
        CountryCode: this.countryCode,
        RegistrationNumber: this.licensePlate,
        DamageZoneKnown: this.damageZoneKnown,
        DamageZones: this.damageZones,
        IsCounterPartyLicensePlateKnown: this.isCounterPartyLicensePlateKnown,
        IsCounterPartyLicensePlateDanish: this.isCounterPartyLicensePlateDanish,
        IsCounterPartyRegistrationCountryKnown: this.isCounterPartyRegistrationCountryKnown,
        IsCounterpartyContactInformationKnown: this.isCounterpartyContactInformationKnown,
        CounterPartyHasDanishResidence: this.counterPartyHasDanishResidence,
        CounterPartyCarRegistrationCountry: this.selectedCounterPartyRegistrationCountry?.Label,
        ContactInformation: {
          FirstName: this.firstName,
          LastName: this.lastName,
          SelectedAddress: this.selectedAddress,
          Address: this.address,
          Phone: this.phone,
          Email: this.email,
        }
      });
    },
    updateLicensePlate() {
      if (this.isCounterPartyLicensePlateDanish === false) {
        this.emit();
      }
    },
    resetAddress() {
      this.selectedAddress = null;
      this.address = {
        ContactAddressId: 0,
        Id: 0,
        Street: null,
        HouseNumber: null,
        Floor: null,
        Designation: null,
        District: null,
        PostalCode: null,
        City: null,
        CountryRef: 0,
        CountryName: null,
        CountryCode: null,
        IsForeignAddress: false,
        Locality: null 
      };

      this.counterPartyInternationalAddress = {
        streetName: null,
        streetNumber: null,
        city: null,
        postalCode: null,
        country: {
          Id: null,
          Label: null
        }
      };

      this.emit();
    },
    resetContactInformation() {
      this.firstName = null;
      this.lastName = null;
      this.phone = null;
      this.email = null;

      this.emit();
    },
    onIsCounterPartyLicensePlateKnownChange(newValue) {
      this.isCounterPartyLicensePlateKnown = newValue;

      this.emit();
    },
    onIsCounterPartyLicensePlateDanishChange(newValue) {
      this.isCounterPartyLicensePlateDanish = newValue;

      if (this.isCounterPartyLicensePlateDanish === true) {
        this.selectedCounterPartyRegistrationCountry = null;
        this.isCounterPartyRegistrationCountryKnown = true;
      }

      this.emit();
    },
    onIsCounterPartyRegistrationCountryKnownChange(newValue) {
      this.isCounterPartyRegistrationCountryKnown = newValue;

      if (this.isCounterPartyRegistrationCountryKnown === false) {
        this.selectedCounterPartyRegistrationCountry = null;
      };

      this.emit();
    },
    onCounterPartyContactInformationChange(newValue) {
      this.isCounterpartyContactInformationKnown = newValue;

      if(this.isCounterpartyContactInformationKnown === false) {
        this.resetAddress();
        this.resetContactInformation();
      };

      this.emit();
    },
    onCounterpartyHasDanishResidenceChange(newValue) {
      this.counterPartyHasDanishResidence = newValue;

      if (this.counterPartyHasDanishResidence === false) {
        this.selectedAddress = null;
      }
      if(this.counterPartyHasDanishResidence === true) {
        this.counterPartyInternationalAddress.country = null;
      }

      this.emit();
    },
    name(fieldName) {
      return 'counterparty-' + this.index + '-' + fieldName;
    },
    licensePlateFound(licensePlate) {
      this.emit();
      this.licensePlateString = licensePlate;
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';

.car {
  line-height: rem-calc(40);
}
</style>
